import React, { useContext } from 'react';

import { Features } from '../../types/features';
import { useSelectFeaturesLoaded, useSelectFeatures } from '../../selectors';

interface FeatureFlagContext {
	features: Features;
	featuresLoaded: boolean;
}

export const FeatureFlagContext = React.createContext<FeatureFlagContext>({
	features: {},
	featuresLoaded: false,
});

export const useFeatureFlags = (): FeatureFlagContext =>
	useContext(FeatureFlagContext);

interface FeatureFlagProviderProps {
	children: React.ReactElement | React.ReactElement[] | null;
}

/**
 * Feature flag context surface. LaunchDarkly is now initialized by the
 * initialization hook (runFlags); this provider only exposes the resolved
 * flags from Redux.
 */
export const FeatureFlagProvider = ({
	children,
}: FeatureFlagProviderProps): JSX.Element | null => {
	const featuresLoaded = useSelectFeaturesLoaded();
	const features = useSelectFeatures();

	return (
		<FeatureFlagContext.Provider value={{ features, featuresLoaded }}>
			{children}
		</FeatureFlagContext.Provider>
	);
};

export default FeatureFlagProvider;
